'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.transformToApiCropMask = exports.updateImage = exports.uploadImageFile = exports.IMAGE_TYPES = exports.IMAGE_TYPE_STRUCTURED_CONTENT = exports.IMAGE_TYPE_USER_PHOTO = exports.IMAGE_TYPE_ORG_LOGO = exports.IMAGE_TYPE_EVENT_LOGO = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _fetch = require('./fetch');

var _upload = require('./upload');

var _form = require('./form');

var _featureDetection = require('../feature-detection');

/**
 * These are the types available in our APIv3 media endpoint.
 * core/django/src/www/eventbrite/ebapi/views/media.py
 * core/django/src/www/eventbrite/ebapi_service/actions/media.py
 */
var IMAGE_TYPE_EVENT_LOGO = exports.IMAGE_TYPE_EVENT_LOGO = 'image-event-logo';
var IMAGE_TYPE_ORG_LOGO = exports.IMAGE_TYPE_ORG_LOGO = 'image-organizer-logo';
var IMAGE_TYPE_USER_PHOTO = exports.IMAGE_TYPE_USER_PHOTO = 'image-user-photo';
var IMAGE_TYPE_STRUCTURED_CONTENT = exports.IMAGE_TYPE_STRUCTURED_CONTENT = 'image-structured-content';
var IMAGE_TYPES = exports.IMAGE_TYPES = [IMAGE_TYPE_EVENT_LOGO, IMAGE_TYPE_ORG_LOGO, IMAGE_TYPE_USER_PHOTO, IMAGE_TYPE_STRUCTURED_CONTENT];

var BASE_MEDIA_URL = '/api/v3/media/';
var UPLOAD_URL = BASE_MEDIA_URL + 'upload/';

/**
 * Initiates image upload and receives necessary credentials
 *
 * @param type - the image type that is being uploaded
 * @returns Promise
 */
var startImageUpload = function startImageUpload(type) {
    return (0, _fetch.fetchJSON)(UPLOAD_URL + '?type=' + type);
};

/**
 * Combines file object into necessary credential form values to upload.
 *
 * @param {string} url - the URL to which it should upload
 * @param {object} uploadData - a plain object with necessary form values
 * @param {File} file - a File object taken from a drop or browse event
 * @param {(percentLoaded: number) => void} onProgress - function that will be invoked on each progress event
 * @returns Promise<string>
 */
var transportFile = function transportFile(url, uploadData, file, onProgress) {
    return (0, _upload.httpWithUploadProgress)(url, (0, _form.objectToFormData)(_extends({}, uploadData, { file: file })), onProgress);
};

/**
 * Finalizes image upload which creates a local image record
 *
 * @param {string} uploadToken - identifying token received when image upload is started
 * @param {object} apiCropMask
 * @returns {Promise<Response>}
 */
var finishImageUpload = function finishImageUpload(uploadToken, apiCropMask) {
    return (0, _fetch.fetchEB)(UPLOAD_URL, {
        method: 'POST',

        body: JSON.stringify(_extends({
            'upload_token': uploadToken
        }, apiCropMask))
    }).then(function (response) {
        return response.json();
    });
};

/**
 * Given a file object and type, upload an image via our API
 *
 * @param {File} file - a File object taken from a drop or browse event
 * @param {'image-event-logo' | 'image-organizer-logo' | 'image-user-photo' | 'image-structured-content'} type - the image type that is being uploaded
 * @param {(percentLoaded: number) => void} onProgress - function that will be invoked on each progress event
 * @param {object} apiCropMask
 * @returns {Promise<Response>}
 */
var uploadImageFile = exports.uploadImageFile = function uploadImageFile(file, type, onProgress, apiCropMask) {
    if (!_featureDetection.HAS_FORM_DATA) {
        return Promise.reject('Unable to uploadImageFile in environment without FormData');
    }

    return startImageUpload(type).then(function (response) {
        return transportFile(response['upload_url'], response['upload_data'], file, onProgress).then(function () {
            return response['upload_token'];
        });
    }).then(function (token) {
        return finishImageUpload(token, apiCropMask);
    });
};

/**
 * Update given image ID with given crop mask.  This will result in a new image record
 * with the new crop mask applied.
 *
 * @param {string} imageId - id of the image to update
 * @param {object} apiCropMask - a crop mask formatted correctly for API interaction
 *      {top_left: {x,y}, width, height}
 */
var updateImage = exports.updateImage = function updateImage(imageId, apiCropMask) {
    return (0, _fetch.fetchJSON)('' + BASE_MEDIA_URL + imageId + '/', {
        method: 'POST',
        body: JSON.stringify(apiCropMask)
    });
};

/**
 * Transform a crop mask object to parameters formatted for an API request
 *
 * @param {object} cropMask - An object with x, y, width, height
 * @param {number} cropMask.x
 * @param {number} cropMask.y
 * @param {number} cropMask.width
 * @param {number} cropMask.height
 * @returns {{'crop_mask.top_left.x': number, 'crop_mask.top_left.y': number, 'crop_mask.width': number, 'crop_mask.height': number}}
 */
var transformToApiCropMask = exports.transformToApiCropMask = function transformToApiCropMask(_ref) {
    var x = _ref.x,
        y = _ref.y,
        width = _ref.width,
        height = _ref.height;
    return {
        'crop_mask.top_left.x': x,
        'crop_mask.top_left.y': y,
        'crop_mask.width': width,
        'crop_mask.height': height
    };
};